var map = {
	"./amore.svg": 4114,
	"./amway.svg": 7550,
	"./besthospital.svg": 2360,
	"./bodyfriend.svg": 5587,
	"./checkup.svg": 1279,
	"./hanhwa.svg": 9301,
	"./hd.svg": 8422,
	"./hdsteel.svg": 6433,
	"./hospital.svg": 8777,
	"./isolation.svg": 1900,
	"./kepco.svg": 1089,
	"./kfa.svg": 7427,
	"./koreapark.svg": 235,
	"./kuni.svg": 9590,
	"./naver.svg": 7394,
	"./ncsoft.svg": 3862,
	"./oil.svg": 1773,
	"./samsung.svg": 6169,
	"./skhynix.svg": 9607,
	"./wonju.svg": 3183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9435;